const scale = (size: number) => size;
const verticalScale = (size: number) => size;
const moderateScale = (size: number) => size;
const moderateVerticalScale = (size: number) => size;

export { scale, verticalScale, moderateScale, moderateVerticalScale };
